export default __webpack_public_path__ + "static/media/fraps.d44f2dfc.png";